/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Feat_Elite_Ai_DescInputs */

const en_upgrade_feat_elite_ai_desc = /** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full RAG engine for your storefront concierge.`)
};

const es_upgrade_feat_elite_ai_desc = /** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor RAG completo para el conserje de tu tienda.`)
};

const fr_upgrade_feat_elite_ai_desc = /** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moteur RAG complet pour le concierge de votre vitrine.`)
};

const de_upgrade_feat_elite_ai_desc = /** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige RAG-Engine für den Concierge deiner Storefront.`)
};

const id_upgrade_feat_elite_ai_desc = /** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesin RAG penuh untuk pramutamu etalase Anda.`)
};

/** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */
const ja_upgrade_feat_elite_ai_desc = en_upgrade_feat_elite_ai_desc;

/** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */
const zh_upgrade_feat_elite_ai_desc = en_upgrade_feat_elite_ai_desc;

/** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */
const ar_upgrade_feat_elite_ai_desc = en_upgrade_feat_elite_ai_desc;

/** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */
const it_upgrade_feat_elite_ai_desc = en_upgrade_feat_elite_ai_desc;

/** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */
const ru_upgrade_feat_elite_ai_desc = en_upgrade_feat_elite_ai_desc;

/** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */
const pt_upgrade_feat_elite_ai_desc = en_upgrade_feat_elite_ai_desc;

/** @type {(inputs: Upgrade_Feat_Elite_Ai_DescInputs) => LocalizedString} */
const ko_upgrade_feat_elite_ai_desc = en_upgrade_feat_elite_ai_desc;

/**
* | output |
* | --- |
* | "Full RAG engine for your storefront concierge." |
*
* @param {Upgrade_Feat_Elite_Ai_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_feat_elite_ai_desc = /** @type {((inputs?: Upgrade_Feat_Elite_Ai_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Feat_Elite_Ai_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "es") return es_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "fr") return fr_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "de") return de_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "ja") return ja_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "zh") return zh_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "ar") return ar_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "id") return id_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "it") return it_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "ru") return ru_upgrade_feat_elite_ai_desc(inputs)
	if (locale === "pt") return pt_upgrade_feat_elite_ai_desc(inputs)
	return ko_upgrade_feat_elite_ai_desc(inputs)
});